import Vue from 'vue';
import moment from './lib/moment';

Vue.filter('formatDate', (date, format = 'DD.MM.YYYY') => {
  return date ? moment(date).format(format) : '';
});

Vue.filter('formatDateTime', (datetime, format = 'HH:mm, DD.MM.YYYY') => {
  return datetime ? moment(datetime).format(format) : '';
});

Vue.filter('truncateText', (text, startLength, endLength = 0) => {
  if (typeof text !== 'string' || text.length <= startLength + endLength) {
    return text;
  }

  let startText = text.substr(0, startLength),
    endText = endLength ? text.substr(-endLength) : '';

  return `${startText}...${endText}`;
});

Vue.filter('sanitizeText', text => {
  return typeof text === 'string'
    ? text
        .replace(/&nbsp;/gim, '\u00A0')
        .replace(/<style>[^<]*<\/style>|<\/?[a-z][^>]*>/gim, '')
    : text;
});

Vue.filter('pluralForm', (n, form1, form2, form5, join = false) => {
  let form,
    n2 = Math.abs(n) % 100;

  if (n2 > 10 && n2 < 20) {
    form = form5;
  } else {
    let n1 = n2 % 10;
    form = n1 > 1 && n1 < 5 ? form2 : n1 === 1 ? form1 : form5;
  }
  return join ? `${n} ${form}` : form;
});
